import React, { memo, useState } from "react"
import {
  Card,
  CardHeader,
  Row,
  Col,
  CardBody,
  Button,
  FormGroup,
  Input,
  Label,
  InputGroup,
  InputGroupText,
  FormFeedback,
} from "reactstrap"
import Select from "react-select"
import AttendanceAction from "store/attendance-resource/actions"
import { useDispatch, useSelector } from "react-redux"

const CardAdditionalWork = ({ validation }) => {
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  React.useEffect(() => {
    dispatch(AttendanceAction.getOtherWork())
  }, [])

  const handleClickAddNewWork = (e, id) => {
    validation.setFieldValue("otherWorks", [
      ...validation.values.otherWorks,
      {
        otherWorkId: 0,
        otherWorkName: "",
        hour: 0,
        minute: 0,
      },
    ])
  }

  const handleDelete = index => {
    const otherWorks = validation.values.otherWorks
    otherWorks.splice(index, 1)
    validation.setFieldValue("otherWorks", otherWorks)
  }

  return validation.values.otherWorks.map((item, k) => (
    <Card key={item.id} className=" p-1">
      <CardHeader className="bg-white">
        <Row className="justify-content-between">
          <Col sm="6" className="d-flex align-items-center">
            {item.titleHeader}
          </Col>
          <Col sm="6" className="d-flex justify-content-end align-items-center">
            <Button
              className={`rounded-circle border border-1 border-dark d-flex align-items-center justify-content-center ${
                k != validation.values.otherWorks.length - 1 &&
                "bg-danger border-danger"
              }`}
              style={{ width: 30, height: 30 }}
              onClick={e => {
                if (k == validation.values.otherWorks.length - 1) {
                  handleClickAddNewWork()
                } else {
                  handleDelete(k)
                }
              }}
            >
              {k == validation.values.otherWorks.length - 1 ? "+" : "-"}
            </Button>
          </Col>
        </Row>
      </CardHeader>
      <CardBody className="pt-3 pb-1">
        <Row>
          <Col sm="12">
            <h6>本日の作業時間</h6>
          </Col>
          <Col sm="6">
            <FormGroup row>
              <InputGroup>
                <Input
                  name={`otherWorks[${k}].hour`}
                  className="form-control"
                  value={validation.values.otherWorks[k]?.hour || ""}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched?.otherWorks &&
                    validation.errors?.otherWorks
                      ? validation.touched?.otherWorks[k]?.hour &&
                        validation.errors?.otherWorks[k]?.hour
                        ? true
                        : false
                      : false
                  }
                />
                <InputGroupText>時間</InputGroupText>
                {validation.touched?.otherWorks &&
                validation.errors?.otherWorks ? (
                  <FormFeedback type="invalid">
                    {validation.errors?.otherWorks[k]?.hour}
                  </FormFeedback>
                ) : null}
              </InputGroup>
            </FormGroup>
          </Col>
          <Col sm="6">
            <FormGroup row>
              <InputGroup>
                <Input
                  name={`otherWorks[${k}].minute`}
                  className="form-control"
                  value={validation.values.otherWorks[k]?.minute || ""}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched?.otherWorks &&
                    validation.errors?.otherWorks
                      ? validation.touched?.otherWorks[k]?.minute &&
                        validation.errors?.otherWorks[k]?.minute
                        ? true
                        : false
                      : false
                  }
                />
                <InputGroupText>分</InputGroupText>
                {validation.touched?.otherWorks &&
                validation.errors?.otherWorks ? (
                  <FormFeedback type="invalid">
                    {validation.errors?.otherWorks[k]?.minute}
                  </FormFeedback>
                ) : null}
              </InputGroup>
            </FormGroup>
          </Col>
          <Col sm="12">
            <FormGroup row>
              <Label sm="4">その他作業</Label>
              <Col sm={8}>
                <Select
                  isLoading={store.attendance.otherWork.loading}
                  options={store.attendance.otherWork.data.map(i => ({
                    label: i.name,
                    value: i.id,
                  }))}
                  value={{
                    label: validation.values.otherWorks[k]?.otherWorkName,
                    value: validation.values.otherWorks[k]?.otherWorkId,
                  }}
                  defaultValue={{
                    label: validation.values.otherWorks[k]?.otherWorkName,
                    value: validation.values.otherWorks[k]?.otherWorkId,
                  }}
                  onChange={e => {
                    if (e) {
                      validation.setFieldValue(
                        `otherWorks.${k}.otherWorkId`,
                        e.value
                      )
                      validation.setFieldValue(
                        `otherWorks.${k}.otherWorkName`,
                        e.label
                      )
                    } else {
                      validation.setFieldValue(
                        `otherWorks[${k}].otherWorkId`,
                        ""
                      )
                      validation.setFieldValue(
                        `otherWorks[${k}].otherWorkName`,
                        ""
                      )
                    }
                  }}
                  isClearable
                />
                <Input
                  name={`otherWorks[${k}].otherWorkId`}
                  className="form-control d-none"
                  value={validation.values.otherWorks[k]?.otherWorkId || ""}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched?.otherWorks &&
                    validation.errors?.otherWorks
                      ? validation.touched?.otherWorks[k]?.otherWorkId &&
                        validation.errors?.otherWorks[k]?.otherWorkId
                        ? true
                        : false
                      : false
                  }
                />
                {validation.touched?.otherWorks &&
                validation.errors?.otherWorks ? (
                  <FormFeedback type="invalid">
                    {validation.errors?.otherWorks[k]?.otherWorkId}
                  </FormFeedback>
                ) : null}
              </Col>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  ))
}

export default memo(CardAdditionalWork)
